import { IDiscounts } from "modules/order/domain/models/IDiscounts";
import { IDiscountsService } from "../interfaces/IDiscountsService";
import { ErrorCodeType } from "application/models/IError";
import { GetError } from "utils/GetError";

export const GetCustomerDiscountsUseCase = async (
  service: IDiscountsService,
  cpf: string,
  eventId: string
): Promise<IDiscounts[] | null> => {
  try {
    return await service.getUserDiscounts(cpf, eventId);
  } catch (error) {
    GetError(
      error,
      "GetCustomerDiscountsUseCase",
      "GetCustomerDiscountsUseCase",
      "Falha ao obter descontos do cliente",
      ErrorCodeType.GENERAL
    );
    return null;
  }
};
